import dayjs from 'dayjs';
import type { TenantOrder } from '@/mocks/orders';
import type { MockReceipt } from '../components/OrderReceiptsList';

/**
 * Dựng danh sách phiếu thu hiển thị của một đơn.
 *
 * Nguồn DUY NHẤT là `accounting.documents[]` lọc `cash_receipt` — chứng từ kế toán nội bộ mà
 * BE đã denormalize sẵn (xem `OrderAccountingDocRef` trong tcr-erp-shared), cùng nguồn với
 * khối "Chứng từ kế toán". Mã / ngày / số tiền lấy nguyên từ đó.
 *
 * KHÔNG dựng lại từ `payments[]`: `Payment` schema không khai `id`, `code`, `amount`,
 * `reference` nên Mongoose (strict) cắt sạch lúc save; đọc lại chỉ còn `voucher_no` và
 * `voucher_id`. Payment nào chưa từng sinh phiếu thu (thu tại quầy POS) sẽ rơi vào nhánh
 * fallback và BỊA ra mã kiểu `PT000`.
 *
 * Tách khỏi `detail.tsx` (TCR-1095) để dialog xem nhanh ở danh sách đơn hiện ĐÚNG danh sách
 * phiếu thu mà trang chi tiết hiện — hai nơi không thể lệch nhau.
 */
export function buildOrderReceipts(order: TenantOrder | undefined): MockReceipt[] {
  const receiptDocs = (order?.accounting?.documents ?? []).filter(
    (doc) => doc?.type === 'cash_receipt',
  );

  return receiptDocs.map((doc, index) => {
    // Tiền mặt hay chuyển khoản KHÔNG có trong `documents[]`. Đối chiếu trong CHÍNH document
    // đơn (`payments[].voucher_id` === `doc_id`, khoá thật, 1-1) chỉ để lấy cái nhãn TM/CK —
    // không đọc thêm collection nào. Không khớp thì bỏ nhãn, không đoán.
    const payment = (order?.payments ?? []).find((item) => {
      const voucherId = (item as { voucher_id?: string })?.voucher_id;
      return voucherId != null && String(voucherId) === String(doc.doc_id);
    });

    return {
      id: String(doc.doc_id || `rcpt-${index}`),
      docId: doc.doc_id ? String(doc.doc_id) : undefined,
      code: doc.code || '(không có số)',
      type: payment ? ((payment.method === 'cash' ? 'TM' : 'CK') as 'TM' | 'CK') : undefined,
      date: doc.doc_date ? dayjs(doc.doc_date).format('DD/MM/YYYY') : '',
      customerInfo: order?.customer?.name || '',
      amount: Number(doc.amount) || 0,
    };
  });
}
